import { render, staticRenderFns } from "./ShiftSetting.vue?vue&type=template&id=3b87c573&scoped=true&"
import script from "./ShiftSetting.vue?vue&type=script&lang=js&"
export * from "./ShiftSetting.vue?vue&type=script&lang=js&"
import style0 from "./ShiftSetting.vue?vue&type=style&index=0&id=3b87c573&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b87c573",
  null
  
)

export default component.exports